import ApiClient from "./ApiClient";

class TranslationService extends ApiClient {
  constructor() {
    super("/translation");
  }
}

export default new TranslationService();
